/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        $(document).foundation(); // Foundation JavaScript

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


//
$(document).ready(function()
{
  // functions
  var newID = '';
  var currentID = '';

  var activate_form_section = function ( object )
    {

      newID = $(object).attr("href");
      var tab = '';

      if (currentActive === false) {
            event.preventDefault();
            $(object).parent().addClass("current");
            $(object).parent().siblings().removeClass("current");
            $(object).css("background-color", "#90C310");
            $(".form-container").css("display", "block");
            tab = $(object).attr("href");
            $(".form-section").not(tab).css("display", "none");
            $(tab).fadeIn();
            currentActive = true;
            currentID = $(object).attr("href");
          }
          else if ((currentActive === true) && (currentID !== newID) ){
            $(object).parent().addClass("current");
            $(object).parent().siblings().removeClass("current");
            $("#footer-menu a").css("background-color", "transparent");
            $(object).css("background-color", "#90C310");
            tab = $(object).attr("href");
            $(".form-section").not(tab).css("display", "none");
            $(tab).fadeIn();
            currentActive = true;
            currentID = $(object).attr("href");
          }
          else {
          $(".form-container").css("display", "none");
              $(object).css("background-color", "transparent");
              $(".form-section").css("display", "none");
              currentActive = false;
          }
      };

  //manages menu dropdown functionality

  $( "#menu" ).click(function() {

     // cancel default event propagation
          event.preventDefault();

          var href = $(this).attr('href').replace(/^.*#/, '');

    $( "#menu-dropdown" ).toggle();
      // Animation complete.

      if ($( "#menu-dropdown" ).is(':visible')) {
        $("#box-shadow-menu").removeClass("box-shadow-menu").addClass("box-shadow-menu-jq");
      }
      else{
        $("#box-shadow-menu").removeClass("box-shadow-menu-jq").addClass("box-shadow-menu");
      }

  });

  $("#donacion-dropdown a").click(function(event) {

    $("#box-shadow-menu").removeClass("box-shadow-menu-jq").addClass("box-shadow-menu");
    $( "#menu-dropdown" ).toggle();
  });

  // Handles the links for the forms
  $(".dropdown-form-link").click(function(event) {
        $("#box-shadow-menu").removeClass("box-shadow-menu-jq").addClass("box-shadow-menu");
        $( "#menu-dropdown" ).toggle();
        newID = $(this).attr("href");
        var footerButtonID = '';

        if (currentActive === false) {
          activate_form_section( $(this) );
          footerButtonID = $(this).attr("href") + '-button';
          $(footerButtonID).css("background-color", "#90C310");
          currentActive = true;
        }
        else if ( (currentActive === true ) && (currentID !== newID) ) {
          activate_form_section( $(this) );
          footerButtonID = $(this).attr("href") + '-button';
          $(footerButtonID).css("background-color", "#90C310");
          currentActive = true;
        }
        $("#menu-dropdown a").css("background-color", "transparent");
        currentID = newID;
  });

//---------- handles the functionality for all anchor tags -----------

    //Cerrar Button
    $("#btnCerrar-donacion").click(function(event) {

      //Hide the form section
      $(".form-container").css("display", "none");
      $(".form-section").css("display", "none");

    });


    //---------- Manages the Footer functionality ----------

    currentActive = false;

    $("#footer-menu a").click(function(event) {

      activate_form_section( $(this) );

    });

    //---------- Scroll to a specific section ----------

    // smooth scrolling
    $(function() {
        var screenWidth = $(window).width();

        // scroll handler
        var scrollToAnchor = function( id ) {
        // grab the element to scroll to based on the name
        var elem = $("[name='"+ id +"']");
        // if that didn't work, look for an element with our ID
        if ( typeof( elem.offset() ) === "undefined" ) {
          elem = $("#"+id);
        }
        // if the destination element exists
        if ( typeof( elem.offset() ) !== "undefined" ) {

          if (screenWidth < 640 ) {
            // do the scroll for small screen
           $('html, body').animate({
              scrollTop: elem.offset().top -50 }, 500 );
          }
          else {
             // do the scroll for medium and large screen
           $('html, body').animate({
              scrollTop: elem.offset().top -75 }, 500 );
          }
        }
        };
        // bind to click event for footer menu
        $("#footer-menu a, #menu-dropdown a").click(function( event ) {
        // only do this if it's an anchor link
        if ( $(this).attr("href").match('#') ) {
          // cancel default event propagation
          event.preventDefault();
          // scroll to the location
          var href = $(this).attr('href').replace(/^.*#/, '');
          scrollToAnchor( href );
        }
        });

        // bind to click event for donacion button
        $("#donacion-button a").click(function( event ) {
        //Set the section form to false, so the footer resets.
        currentActive = false;
        //display the donation section
        $(".form-section").css("display", "none");
        $(".form-container").css("display", "block");
        $("#donacion").css("display", "block");
        //Unselect all the footer buttons
        $("#footer-menu a").css("background-color", "transparent");
        // only do this if it's an anchor link
        if ( $(this).attr("href").match('#') ) {
          // cancel default event propagation
          event.preventDefault();
          // scroll to the location
          var href = $(this).attr('href').replace(/^.*#/, '');
          scrollToAnchor( href );
        }
        });

         // bind to click event for donacion button
        $(".dropdown-inside-btn a").click(function( event ) {
        //Set the section form to false, so the footer resets.
        currentActive = false;
        //display the donation section
        $(".form-section").css("display", "none");
        $(".form-container").css("display", "block");
        $("#donacion").css("display", "block");
        //Unselect all the footer buttons
        $("#footer-menu a").css("background-color", "transparent");
        // only do this if it's an anchor link
        if ( $(this).attr("href").match('#') ) {
          // cancel default event propagation
          event.preventDefault();
          // scroll to the location
          var href = $(this).attr('href').replace(/^.*#/, '');
          scrollToAnchor( href );
        }
        });
    });

});


